export enum FormulasMode {Amount= 1 , Formulas= 2}
